import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './localization/en.json'; // default en json
// Individual files for specific components
import ambassadorEn from './components/ambassadors/localization/en.json';
import attendanceEn from './components/attendance/localization/en.json';
import activityEn from './components/myActivity/localization/en.json';
import eventsEn from './components/events/localization/en.json';
import shiftsEn from './components/shifts/localization/en.json';
import signupEn from './components/manageSignup/localization/en.json';
import coordinatorManageWaitlistEn from './components/coordinatorManageWaitlist/localization/en.json';
import richTextEditorEn from './components/richTextEditor/localization/en.json';
import nonprofitsEn from './components/nonprofits/localization/en.json';

const translationResources = {
  en: {
    translation: en,
    attendance: attendanceEn,
    ambassadors: ambassadorEn,
    activity: activityEn,
    events: eventsEn,
    shifts: shiftsEn,
    signup: signupEn,
    coordinatorManageWaitlist: coordinatorManageWaitlistEn,
    richTextEditor: richTextEditorEn,
    nonprofits: nonprofitsEn,
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({ resources: translationResources, fallbackLng: 'en', fallbackNS: 'translation' });

export default i18n;
